import { ColumnDef } from "@tanstack/react-table";
import { format } from "date-fns";

import { Lead } from "./schema";

import { DataTableColumnHeader } from "./data-table-column-header";
import { Badge } from "@/components/ui/badge/badge";
import { convertUTCtoISTWithMinus } from "@/utils";
import { DataTableSearchableColumn } from "@/types/tables";

export function getColumns(): ColumnDef<Lead>[] {
  return [
    {
      accessorKey: "assignedStatus",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Index" />
      ),
      cell: ({ row }) => {
        return (
          <div className="flex flex-col gap-1">
            <span>{row.index + 1}</span>
            {row.original.createdAt && (
              <div className="text-[12px]">
                ( Created at -{" "}
                {format(new Date(row.original.createdAt), "PPpp")} )
              </div>
            )}
            {row.original.allotedAt && (
              <div className="text-[12px]">
                ( Assigned at -{" "}
                {format(
                  convertUTCtoISTWithMinus(row.original.allotedAt),
                  "PPpp"
                )}{" "}
                )
              </div>
            )}
          </div>
        );
      },
      filterFn: (row, id, value) => {
        return value.includes(row.getValue(id));
      },
      enableSorting: false,
    },
    {
      accessorKey: "name",
      header: ({ column }) => {
        return <DataTableColumnHeader column={column} title="Name" />;
      },
      cell: ({ row }) => {
        return (
          <div className="flex space-x-2">
            <span className="max-w-[500px] truncate font-medium">
              {row.getValue("name")}
            </span>
          </div>
        );
      },
    },

    {
      accessorKey: "broker",
      header: ({ column }) => {
        return <DataTableColumnHeader column={column} title="Broker" />;
      },
      cell: ({ row }) => {
        return (
          <div className="flex space-x-2">
            <span className="max-w-[500px] truncate font-medium">
              {row.getValue("broker")}
            </span>
          </div>
        );
      },
      filterFn: (row, id, value) => {
        return value.includes(row.getValue(id));
      },
    },

    {
      accessorKey: "phone",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Phone" />
      ),
      cell: ({ row }) => {
        return (
          <div className="flex space-x-2">
            <span className="max-w-[500px] truncate font-medium">
              {row.getValue("phone")}
            </span>
          </div>
        );
      },
    },

    {
      accessorKey: "originalStatus",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Lead Status" />
      ),
      cell: ({ row }) => {
        return (
          <div className="flex space-x-2">
            <Badge>{row.getValue("originalStatus")}</Badge>
          </div>
        );
      },
    },

    {
      accessorKey: "status",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Calling Status" />
      ),
      cell: ({ row }) => {
        return (
          <div className="flex space-x-2">
            <Badge>{row.getValue("status")}</Badge>
          </div>
        );
      },
    },

    {
      accessorKey: "allotedTo",
      header: ({ column }) => {
        return <DataTableColumnHeader column={column} title="Alloted To" />;
      },
      cell: ({ row }) => {
        const originData = row.original as Lead & {
          allotedToEmail: string;
        };
        return (
          <div className="flex flex-col gap-2">
            <span className="max-w-[500px] truncate font-medium">
              {row.getValue("allotedTo")}
            </span>
            {originData.allotedToEmail && (
              <span className="max-w-[500px] truncate font-medium">
                ( {originData.allotedToEmail} )
              </span>
            )}
          </div>
        );
      },
    },

    // {
    //   id: "actions",
    //   cell: ({ row }) => <DataTableRowActions row={row} />,
    // },
  ];
}

export const searchableColumns: DataTableSearchableColumn<Lead>[] = [
  {
    id: "name",
    placeholder: "Filter name...",
  },
];
